import React from 'react';
import { IconProps } from './types';

const Gift2: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="gift2-123"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="12"
        height="12"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H12V12H0V0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#gift2-123)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.851288 5.6723H5.57446V3.24557H0.851288V5.6723ZM3.23415 1.6079C3.22607 1.22706 3.50974 0.909354 3.87242 0.893275C4.68089 0.893275 5.17732 1.75677 5.40426 2.35229H3.87242C3.50534 2.32088 3.22536 1.99439 3.23415 1.6079V1.6079ZM8.12753 0.893275C8.49006 0.909354 8.77374 1.22706 8.7658 1.6079C8.77445 1.99439 8.4946 2.32088 8.12753 2.35229H6.59569C6.83681 1.75677 7.31906 0.893275 8.12753 0.893275V0.893275ZM6.42548 5.6723H11.1487V3.24557H6.42548V5.6723ZM6.42548 11.1064H10.5813V6.56557H6.42548V11.1064ZM1.41864 11.1064H5.57446V6.56557H1.41864V11.1064ZM0.000265257 2.79893V6.11894C-0.00781946 6.35729 0.169902 6.55724 0.396842 6.56557C0.406487 6.56602 0.416132 6.56602 0.425776 6.56557H0.567614V11.553C0.559529 11.7914 0.737251 11.9913 0.96419 11.9997C0.973835 12.0001 0.98348 12.0001 0.993125 11.9997H11.0068C11.2338 12.0082 11.4244 11.8218 11.4323 11.5834C11.4328 11.5733 11.4328 11.5632 11.4323 11.553V6.56557H11.5742C11.8011 6.57391 11.9917 6.38751 11.9997 6.14931C12.0001 6.13918 12.0001 6.12906 11.9997 6.11894V2.79893C12.0076 2.56072 11.83 2.36063 11.6031 2.35229C11.5933 2.35199 11.5838 2.35199 11.5742 2.35229H9.44661C9.56065 2.12257 9.61909 1.86695 9.61682 1.6079C9.63242 0.736506 8.97217 0.0166745 8.142 0.000148879L8.12753 0C7.04957 0 6.38293 0.848612 5.99997 1.57812C5.61701 0.848612 4.95038 0 3.87242 0C3.0421 0.00803948 2.37519 0.721171 2.38284 1.59271L2.38313 1.6079C2.38072 1.86695 2.43915 2.12257 2.55333 2.35229H0.425776C0.198695 2.34395 0.00820813 2.53035 0.000265257 2.76871C-1.84173e-05 2.77883 -1.84173e-05 2.78881 0.000265257 2.79893V2.79893Z"
          fill={!ignoreColor ? color : undefined}
        />
      </g>
    </svg>
  );
};

export default Gift2;
